import RoboterService from "@/services/RoboterService.js";

const state = {
  roboter: {
    _id: null,
    name: "",
    standort: "",
    active: true,
    ownerCustomer: null,
    serviceCodes: []
  },
  roboterList: []
};

const getters = {
  getRoboter(state) {
    return state.roboter;
  },
  getRoboterList(state) {
    return state.roboterList;
  }
};

const actions = {
  createRoboterIDs({ commit }) {
    return new Promise((resolve, reject) => {
      RoboterService.createRoboterIDs()
        .then(result => {
          commit("CREATE_ROBOTER", result.data);
          resolve(result.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchRoboterList({ commit }) {
    return new Promise((resolve, reject) => {
      RoboterService.getAll()
        .then(response => {
          commit("SET_ROBOTER_LIST", response.data.data);
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchRoboter({ commit }, id) {
    return new Promise((resolve, reject) => {
      RoboterService.get(id)
        .then(response => {
          commit("SET_ROBOTER", response.data.data);
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveRoboter({ commit, state }) {
    return new Promise((resolve, reject) => {
      RoboterService.save(state.roboter)
        .then(result => {
          commit("ADD_ROBOTER", result.data.data);
          return resolve(result.data.data);
        })
        .catch(error => {
          console.log(error);
          return reject(error);
        });
    });
  },
  deleteRoboter({ commit }, id) {
    return new Promise((resolve, reject) => {
      RoboterService.delete(id)
        .then(() => {
          commit("REMOVE_ROBOTER", id);
          resolve(id);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const mutations = {
  CREATE_ROBOTER(state, value) {
    state.roboter = {
      active: true,
      _id: value.rid,
      serviceCodes: value.serviceCodes
    };
  },
  SET_ROBOTER(state, value) {
    state.roboter = value;
  },
  SET_ROBOTER_LIST(state, value) {
    state.roboterList = value;
  },
  ADD_ROBOTER(state, value) {
    state.roboterList.push(value);
  },
  RESET_CURRENT(state) {
    state.roboter = {
      _id: null,
      name: "",
      standort: "",
      active: true,
      ownerCustomer: null,
      serviceCodes: []
    };
  },
  REMOVE_ROBOTER(state, id) {
    if (state.roboterList) {
      state.roboterList = state.roboterList.filter(item => item._id !== id);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
